<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      {{ footerLabel }}
    </span>
  </p>
</template>

<script>
import packageJson from "../../../../package.json";

const BUILD_NUMBER = "1";

const formatUtcTimestamp = (date) => {
  const pad = (value) => String(value).padStart(2, "0");

  return `${pad(date.getUTCDate())}${pad(date.getUTCMonth() + 1)}${date.getUTCFullYear()}-${pad(date.getUTCHours())}${pad(date.getUTCMinutes())}`;
};

const formatEnvironmentLabel = (environment) => environment
  .split(/[-_\s]+/)
  .filter(Boolean)
  .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
  .join(" ");

export default {
  data() {
    return {
      buildTimestampUtc: formatUtcTimestamp(new Date()),
    };
  },
  computed: {
    footerLabel() {
      const environment = formatEnvironmentLabel(process.env.VUE_APP_ENVIRONMENT || "Unknown");

      return `${environment} - Version ${packageJson.version} Build ${BUILD_NUMBER} - ${this.buildTimestampUtc}`;
    },
  },
};
</script>
